var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-navigator',{attrs:{"swipeable":"","page-stack":_vm.pageStack},on:{"push-page":_vm.pushPage,"pop-page":_vm.popPage,"top-page":_vm.topPage}})}
var staticRenderFns = []

export { render, staticRenderFns }